<template>
  <modal
    class="shortcuts-modal"
    title="Calendar"
    :visible="show"
    :can-close="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <div class="headerWrapper">
        Select day stream
        <el-time-picker
          v-model="checkTimePicker"
          :value-format="'HH:mm:ss'"
          :picker-options="{
            selectableRange: '00:00:00 - 23:59:59'
          }"
          placeholder="Arbitrary time"
          @focus="disabledBtnFocus"
          @blur="disabledBtnUnfocus"
          @change="changeTimePicker"
        >
        </el-time-picker>
        <button :disabled="disabledBtn" @click="changeTimePickerAply">
          Apply
        </button>
      </div>
      <el-calendar v-model="value">
        <template slot="dateCell" slot-scope="{ date, data }">
          <p
            :class="
              (data.isSelected ? 'is-selected' : '',
              isDateBetween(data.day) ? 'stream-day' : 'disabledTd')
            "
          >
            {{
              data.day
                .split("-")
                .slice(2)
                .join("-")
            }}
            <!-- {{ data }} -->
            {{ data.isSelected ? "✔️" : "" }}
          </p>
        </template>
      </el-calendar>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/dialog/Modal.vue";
import { DatePicker, TimeSelect } from "element-ui";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

/** time formatting */
import { getFormatPlayerTime } from "@/utils/time.js";

dayjs.extend(utc);
dayjs.extend(timezone);

// import { lockShortcuts, unlockShortcuts } from "@/utils/shortcuts.js";

export default {
  name: "CalendarInfoModal",
  components: { Modal, [TimeSelect.name]: TimeSelect },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      streamStart: state => state.timeline.ndvrStreamStart,
      streamEnd: state => state.timeline.ndvrStreamEnd,
      streamStartCalendar: state => state.timeline.ndvrStreamStartCalendar,
      stramEndCalendar: state => state.timeline.ndvrStreamEndCalendar,
      timezone: state => state.timezone.timezone,
      playerTime: state => state.ndvrPlayer.displayTimer,
      leftCropBound: state => state.timeline.sliderLeftBound
    }),
    ...mapGetters("timeline", [
      "visibleTimelineLength",
      "isTimelineInited",
      "isTimelineFailed"
    ]),
    formatPlayerTime() {
      const timestamp = this.playerTime;
      return getFormatPlayerTime(timestamp, this.timezone);
    },
    // @vuese
    // User timezone name
    localTimezone: {
      cache: false,
      get() {
        return dayjs.tz.guess();
      }
    },
    // @vuese
    // Stream [start, end] array to pass into ScrollableTimeline
    streamTimerange() {
      return [
        new Date(this.streamStartCalendar * 1000).toISOString().split("T")[0],
        new Date(this.stramEndCalendar * 1000).toISOString().split("T")[0]
      ];
    },
    checkInterwalDay() {
      return this.value.toISOString().split("T")[0];
    }
  },
  data() {
    return {
      value: new Date(),
      checkTimePicker: null,
      startDate: null,
      endDate: null,
      disabledBtn: false
    };
  },
  watch: {
    value() {
      const date = new Date();
      const splitDate = date.toString().split(" ");
      splitDate[4] = "00:00:00";
      const joinDate = splitDate.join(" ");
      this.checkTimePicker = new Date(joinDate);

      const dateParse = new Date().getDate();
      const selectDayParse = new Date(this.value).getDate();
      if (selectDayParse !== dateParse && selectDayParse !== dateParse - 1) {
        this.value = new Date();
        this.$message({
          showClose: true,
          type: "error",
          message: "Stream doesn't exist",
          duration: 3000,
          customClass: "messageErrorCalendar"
        });
      }
    },
    playerTime() {
      if (!this.show) {
        this.checkTimePicker = this.formatPlayerTime;
      }
    }
  },
  methods: {
    ...mapActions("timeline", ["moveSliderBoth"]),
    ...mapMutations("ndvrPlayer", ["setShangeCoursourPositinonCalendar"]),
    ...mapMutations("ndvrPlayer", ["setStopPlayerNdvr"]),
    ...mapMutations("timeline", ["setZoom", "setVisibleRange"]),
    isDateBetween(data) {
      this.startDate = new Date(this.streamTimerange[0]).getDate();
      this.endDate = new Date(this.streamTimerange[1]).getDate();
      if (data == this.streamTimerange[0] || data == this.streamTimerange[1]) {
        return true;
      } else {
        return false;
      }
    },
    disabledBtnFocus() {
      this.disabledBtn = true;
    },
    disabledBtnUnfocus() {
      this.disabledBtn = false;
    },
    changeTimePicker(checkTimePicker) {
      const timeArr = checkTimePicker.split(":");

      const hour = parseInt(timeArr[0]);
      const min = parseInt(timeArr[1]);
      const sec = parseInt(timeArr[2]);

      const getTimeCalendarPicker = dayjs(this.value)
        .set("hour", hour)
        .set("minute", min)
        .set("second", sec)
        .tz(this.timezone, true)
        .unix();

      this.$emit("stopPlayerCalendar");
      this.setStopPlayerNdvr(false);
      this.setShangeCoursourPositinonCalendar(getTimeCalendarPicker);
      this.setVisibleRange([this.streamStart, this.streamEnd]);
      const changeValue = getTimeCalendarPicker - this.leftCropBound;

      this.moveSliderBoth(changeValue);
      this.setZoom(1);
      this.$emit("close");
    },
    changeTimePickerAply() {
      this.setVisibleRange([this.streamStart, this.streamEnd]);
      this.setZoom(1);
      const date = this.value.getDate();

      if (!Date.parse(this.checkTimePicker)) {
        const timeArr = this.checkTimePicker.split(":");
        const hour = parseInt(timeArr[0]);
        const min = parseInt(timeArr[1]);
        const sec = parseInt(timeArr[2]);
        const getTimeCalendarPicker = dayjs(this.value)
          .set("hour", hour)
          .set("minute", min)
          .set("second", sec)
          .tz(this.timezone, true)
          .unix();
        this.setShangeCoursourPositinonCalendar(getTimeCalendarPicker);

        const changeValue = getTimeCalendarPicker - this.leftCropBound;
        this.moveSliderBoth(changeValue);
      } else {
        const getTimeCalendarPickerApply = dayjs(this.checkTimePicker)
          .set("date", date)
          .tz(this.timezone, true)
          .unix();

        const changeValue = getTimeCalendarPickerApply - this.leftCropBound;
        this.setShangeCoursourPositinonCalendar(getTimeCalendarPickerApply);

        this.moveSliderBoth(changeValue);
      }

      this.$emit("close");
    },
    changeLiveFlag() {}
  }
};
</script>

<style>
.headerWrapper {
  display: flex;
  justify-content: space-around;
  margin: 0 0 20px 0;
}

.messageErrorCalendar {
  z-index: 4000 !important;
}

.el-popper {
  z-index: 3300 !important;
}
.el-calendar-table:not(.is-range) td.prev,
.el-calendar-table:not(.is-range) td.next {
  color: #c0c4cc;
}
.el-calendar-table td.is-today {
  color: #409eff;
}
.is-selected {
  color: #1989fa;
}
.stream-day {
  color: #1989fa;
}
.disabledTd {
  color: grey;
  pointer-events: none;
}
</style>
